import { ApiType } from "@gymflow/common/lib/api/ApiType";
import { portalIsLocalhost } from "@gymflow/helpers";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { clubAsPublicQueryKeys } from "./clubAsPublicQueryKeys";

export function useClubPropertiesSettingsAsPublic(
  {
    api,
    clubId,
  }: {
    api: ApiType;
    clubId: number;
  },
  opts?: Omit<
    UseQueryOptions<
      | Awaited<
          ReturnType<ApiType["public"]["clubApi"]["propertiesSettings"]>
        >["data"]
      | null
    >,
    "queryKey"
  >,
) {
  return useQuery({
    queryKey: clubAsPublicQueryKeys.propertiesSettings(clubId),
    queryFn: async () => {
      const result = await api.public.clubApi.propertiesSettings();
      if (portalIsLocalhost()) {
        // Mock featureFlags here
        // result.data.featureFlags.YOUR_FEATURE_FLAG = true;
      }
      return result.data;
    },
    enabled: !!clubId,
    placeholderData: null,
    ...opts,
  });
}
